module.exports = __webpack_public_path__ + "static/media/29BDOS10.5532cd5b.jpg";